// extracted by mini-css-extract-plugin
export default {"canvasLayout":"selector-canvas-view_canvasLayout__LfE+i","canvasContainer":"selector-canvas-view_canvasContainer__HQaBX"};